<template>
  <BaseModal
    :heading="$t('subscription.cancelation_flow.actions.pause')"
    small
    @close="close"
  >
    <Flex>
      <Flex
        direction="column"
        :gap="1.5"
      >
        <BaseAlert
          color="info"
          :text="$t('subscription.cancelation_flow.form_label.temporary_pause', brandName())"
        />
        <BaseRadio
          v-model="selectedDuration"
          :options="[
            {
              label: $t('subscription.cancelation_flow.options.temporary_pause', {
                amount: 3,
              }),
              value: 3,
            },
            {
              label: $t('subscription.cancelation_flow.options.temporary_pause', {
                amount: 4,
              }),
              value: 4,
            },
            {
              label: $t('subscription.cancelation_flow.options.temporary_pause', {
                amount: 5,
              }),
              value: 5,
            },
          ]"
          v-test="'cancel-flow-pause-duration'"
        />
        <BaseText>
          {{ $t('subscription.cancelation_flow.description.temporary_pause', brandName()) }}
        </BaseText>
      </Flex>
      <img
        v-if="$screen !== 's'"
        src="/img/cancel-subscription/person-sitting.svg"
      >
    </Flex>

    <template #footer>
      <BaseButton
        color="inverted"
        @click="$emit('back')"
      >
        {{ $t('global.back') }}
      </BaseButton>
      <BaseButton
        @click="submit"
        :loading="loading"
        v-test="'cancel-flow-pause-submit'"
      >
        {{ $t('subscription.cancelation_flow.actions.pause') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script
  setup
  lang="ts"
>
import { useMutation } from '@vue/apollo-composable';
import { useI18n } from 'vue-i18n';
import { brandName } from '@/helpers/brand-name';
import { flash } from '@/helpers/ui';
import { PAUSE_SUBSCRIPTION_MUTATION } from './graphql';

const emit = defineEmits(['close', 'back']);

const { t } = useI18n();

const selectedDuration = ref<number>(3);

const { mutate, loading } = useMutation(PAUSE_SUBSCRIPTION_MUTATION);

const submit = () => {
  const duration = selectedDuration.value;

  mutate({
    input: {
      duration,
    },
  }).then(() => {
    flash(t('subscription.cancelation_flow.pause_success'));
    emit('close');
  });
};

const close = () => {
  emit('close');
};
</script>
